const apiErrorMappings = {
  name: { 'value is not unique': 'Nama Kolom sudah terdaftar di sistem' },
}

export default apiErrorMappings